import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/geist';
import '@fontsource-variable/dm-sans';
import './styles/tailwind.generated.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { Provider } from 'react-redux'
import { persistor, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import "./i18n/i18.instance";
import { applyEnvironmentFavicon, applyEnvironmentTitle } from "./common/services/environment";

// Add Symbol.observable polyfill before Redux imports
// This fixes the warning: "Symbol.observable as defined by Redux and Redux DevTools do not match"
if (typeof Symbol === 'function' && !Symbol.observable) {
  (Symbol as any).observable = Symbol('observable');
}

// INT and local servers say so: a coloured dot on the favicon and a prefix on
// the tab title. Prod keeps both plain.
void applyEnvironmentFavicon();
applyEnvironmentTitle();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
);

// Installable app + offline shell. Production builds only; see the module.
serviceWorkerRegistration.register();

reportWebVitals();